<template>
  <section id="main" class="main-viewport vb23-main">
    <div class="vb23-container vb23-layout">
      <div class="vb23-sidebar">
        <div class="vb23-sidebar-stack">
          <Sidebar :slug="slug" :type="type"/>
          <a
            v-if="showReferralFinderPromo"
            class="referral-finder-promo referral-finder-promo--desktop"
            href="/tools/referral-link-finder"
          >
            <span class="referral-finder-promo__eyebrow">Creator tools</span>
            <strong>Referral Code &amp; Link Finder</strong>
            <span>Find discounts, free trials, credits, and verified codes for creator tools.</span>
          </a>
        </div>
      </div>

      <section class="vb23-library" aria-labelledby="vb23-library-title">
        <a
          v-if="showReferralFinderPromo"
          class="referral-finder-promo referral-finder-promo--mobile"
          href="/tools/referral-link-finder"
        >
          <span class="referral-finder-promo__eyebrow">Creator tools</span>
          <strong>Referral Code &amp; Link Finder</strong>
          <span>Find discounts, free trials, credits, and verified codes for creator tools.</span>
        </a>
        <div class="d-xl-none" v-if="isMobileViewport">
          <AdsterraBanner placement="library-mobile-top" custom-class="ad-placeholder-mobile" />
        </div>

        <div :class="`vbry-playlist vb23-playlist ${isPlaying ? 'playing' : 'playing animate-paused'}`" id="vinyl_record">
          <div class="playlist-wrap">
            <div class="vb23-hot">
              <div>
                <p class="vb23-hot__eyebrow">{{songType || 'DISCOVER'}}</p>
                <h1 :class="`vb23-hot__title ${isLongPlaylistTitle ? 'long-title' : ''}`" id="vb23-library-title">{{libraryHeading}}</h1>
              </div>
              <div class="vb23-hot__actions">
                <a :class="`play-all vb23-play-all ${hasPlayableSong ? '' : 'disabled'}`" id="play_all" @click.prevent="playAll">
                  <ion-icon :name="`${isPlaying ? 'pause-sharp' : 'play-sharp'}`"></ion-icon>
                  <span>{{isPlaying ? 'Pause' : 'Play All'}}</span>
                </a>
              </div>
            </div>

            <div class="play-table vb23-table">
              <div class="heading vb23-table-head">
                <div class="play-col" aria-hidden="true"></div>
                <div class="title-col">
                  <span>TITLE</span>
                </div>
                <div class="preview-col">
                  <span>PREVIEW</span>
                </div>
                <div class="duration-col">
                  <span>DURATION</span>
                </div>
                <div v-if="!isSoundEffect" class="tempo-col">
                  <span>TEMPO</span>
                </div>
                <div class="download-col" aria-hidden="true"></div>
              </div>
              <div class="queue">
                <template v-for="(song, index) in songs">
                  <div :key="`row-${song.id || song.slug || index}`" class="song-row d-flex" :id="song.slug">
                    <SongWaveSurfer :key="`wave-${song.id || song.slug || index}`" :song="song" :index="index" :selectedSong="selectedSong" :addSong="addSong" :addSoundEffects="addSoundEffects" />
                  </div>
                  <div
                    v-if="showInFeedAd(index)"
                    :key="`infeed-${index}`"
                    class="vb23-infeed-ad"
                  >
                    <AdsterraBanner placement="library-in-feed" custom-class="vb23-infeed-ad__unit" />
                  </div>
                </template>

                <!-- loader-->
                <div v-if="loadMore" class="itm-loader">
                  <div class="song-row d-flex">
                    <div class="play-col px-1 my-auto">
                      <div class="mx-lg-2">
                        <div class="skl-loader-itm"></div>
                      </div>
                    </div>
                    <div class="title-col px-1 my-auto">
                      <div class="skl-loader-itm" style="width:250px; height:21px; animation: loads 30s infinite linear;"></div>
                    </div>
                    <div class="duration-col px-1 my-auto">
                      <div class="skl-loader-itm"></div>
                    </div>
                    <div class="tempo-col px-1 my-auto">
                      <div class="skl-loader-itm"></div>
                    </div>
                    <div class="preview-col flex-grow-1 my-auto mx-lg-4">
                      <div class="skl-loader-itm" style="width: 100%; height:40px; animation: loads 10s infinite linear;"></div>
                    </div>
                    <div class="download-col my-auto mx-lg-2">
                      <div class="skl-loader-itm"></div>
                    </div>
                  </div>
                  <div class="song-row d-flex">
                    <div class="play-col px-1 my-auto">
                      <div class="mx-lg-2">
                        <div class="skl-loader-itm"></div>
                      </div>
                    </div>
                    <div class="title-col px-1 my-auto">
                      <div class="skl-loader-itm" style="width:250px; height:21px; animation: loads 30s infinite linear;"></div>
                    </div>
                    <div class="duration-col px-1 my-auto">
                      <div class="skl-loader-itm"></div>
                    </div>
                    <div class="tempo-col px-1 my-auto">
                      <div class="skl-loader-itm"></div>
                    </div>
                    <div class="preview-col flex-grow-1 my-auto mx-lg-4">
                      <div class="skl-loader-itm" style="width: 100%; height:40px; animation: loads 10s infinite linear;"></div>
                    </div>
                    <div class="download-col my-auto mx-lg-2">
                      <div class="skl-loader-itm"></div>
                    </div>
                  </div>
                </div>
                <!--end loadaer-->
                <AdsterraBanner placement="listing-pre-footer" custom-class="ad-placeholder-prefooter" />
                <div class="seo-load-more-wrap text-center py-4" v-if="pagination && pagination.next_page_url">
                  <a :href="nextPageHref" class="btn yellow-btn" @click.prevent="loadMoreFromButton">Load More</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section v-if="libraryIntro" class="vb23-library-context" aria-labelledby="vb23-library-context-title">
          <p class="vb23-library-context__eyebrow">About this collection</p>
          <h2 id="vb23-library-context-title">{{libraryIntro.title}}</h2>
          <p v-for="paragraph in libraryIntro.body" :key="paragraph">{{paragraph}}</p>
          <nav v-if="libraryIntro.links && libraryIntro.links.length" aria-label="Related music and creator guides">
            <router-link v-for="link in libraryIntro.links" :key="link.to" :to="link.to">{{link.label}}</router-link>
          </nav>
        </section>

        <Footer />
      </section>
    </div>
  </section>
</template>

<style scoped>
@keyframes loads{
  0%{
    background-position: 0px 0;
  }
  100% {
    background-position: 100em 0;
  }
}
.itm-loader{
  position: relative;
  padding: 16px 0px;
}
.skl-loader-itm{
  background-color: rgba(0,0,0,0.05);
  background: linear-gradient(to right, rgba(0,0,0,0.05) 0%, rgba(255,255,255,1) 30%, rgba(0,0,0,0.05) 60%);
  animation: loads 60s infinite linear;
  max-width: 100%;
}
.itm-loader .play-col .skl-loader-itm,
.itm-loader .download-col .skl-loader-itm{
  width:52px; height:52px; border-radius: 100%; animation: loads 60s infinite linear;
}
.itm-loader .tempo-col .skl-loader-itm,
.itm-loader .duration-col .skl-loader-itm{
  width: 70px; height:21px;
}
.itm-loader .song-row{
  padding-bottom: 16px;
}
.library-ad-rail {
  padding: 24px 16px 0 0;
}
.vb23-sidebar-stack {
  position: sticky;
  top: 80px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: calc(100vh - 96px);
  min-height: 0;
}
.referral-finder-promo {
  flex: none;
  display: block;
  margin-top: 0;
  padding: 14px 16px;
  border: 1px solid rgba(116, 179, 163, .24);
  border-radius: 8px;
  background: rgba(116, 179, 163, .08);
  color: var(--vb23-text);
  text-decoration: none;
}
.referral-finder-promo:hover {
  border-color: rgba(255, 211, 0, .5);
  color: var(--vb23-text);
}
.referral-finder-promo__eyebrow,
.referral-finder-promo span {
  display: block;
}
.referral-finder-promo__eyebrow {
  margin-bottom: 5px;
  color: var(--vb23-patina);
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: uppercase;
}
.referral-finder-promo strong {
  display: block;
  color: var(--vb23-text);
  font-size: 14.5px;
  line-height: 1.25;
}
.referral-finder-promo span:not(.referral-finder-promo__eyebrow) {
  margin-top: 5px;
  color: var(--vb23-text-2);
  font-size: 12.5px;
  line-height: 1.45;
}
.referral-finder-promo--mobile {
  display: none;
  margin: 0 0 16px;
}
.vb23-library-context {
  margin: 28px 0 4px;
  padding: 28px 0 8px;
  border-top: 1px solid rgba(37, 37, 37, .12);
  color: var(--vb23-text);
}
.vb23-library-context__eyebrow {
  margin: 0 0 8px;
  color: var(--vb23-patina);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}
.vb23-library-context h2 {
  margin: 0 0 12px;
  font-size: clamp(23px, 3vw, 32px);
  line-height: 1.22;
}
.vb23-library-context p {
  max-width: 820px;
  margin: 0 0 12px;
  color: var(--vb23-text-2);
  line-height: 1.7;
}
.vb23-library-context nav {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}
.vb23-library-context nav a {
  border: 1px solid rgba(37, 37, 37, .16);
  border-radius: 999px;
  color: var(--vb23-text);
  padding: 7px 11px;
  text-decoration: none;
}
.vb23-library-context nav a:hover {
  border-color: var(--vb23-yellow);
  background: var(--vb23-yellow);
}
@media (max-width: 1460px) and (min-width: 992px){
  .itm-loader .play-col .skl-loader-itm,
  .itm-loader .download-col .skl-loader-itm{
    width: 36px;
    height: 36px;
  }
}
@media (max-width: 991px){
  .vb23-sidebar-stack {
    position: static;
    display: block;
    height: auto;
    max-height: none;
  }
  .referral-finder-promo--desktop {
    display: none;
  }
  .referral-finder-promo--mobile {
    display: block;
  }
  .itm-loader .duration-col:before,
  .itm-loader .tempo-col:before{
    display: none;
  }
  .itm-loader .download-col .skl-loader-itm{
    width: 100%;
    border-radius: 0;
  }
  .itm-loader .tempo-col .skl-loader-itm{
    margin-left: auto;
  }
  .itm-loader .tempo-col .skl-loader-itm,
  .itm-loader .duration-col .skl-loader-itm{
    width: 120px; height:21px;
  }
  .itm-loader .song-row{
    padding-bottom: 24px;
  }
}
</style>

<script>
import Sidebar from "../partials/Sidebar.vue";
import Footer from "../partials/Footer.vue";
import AdsterraBanner from "../partials/AdsterraBanner.vue";
import constant from "../../constants/constant";
import { DownloadIcon, ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons';
import { mapGetters, mapActions } from 'vuex';
import SongWaveSurfer from '../pages/SongWaveSurfer.vue';
import { debounce } from 'lodash';
import { categoryLandingContent } from '../../content/seoGrowthContent';

export default {
  props: ['type', 'slug'],
  components: {
    Footer,
    AdsterraBanner,
    Sidebar,
    DownloadIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    SongWaveSurfer
  },
  data() {
    return {
      playlistSongLabel: 'Song',
      MAIN_URL: '',
      newSongTitle: '',
      newSongShortTrack: '',
      loadMore: false,
      paginationNumber: 1,
      isSoundEffect: false,
      isLastPage:false,
      restoreStateApplied: false,
      inFeedAdInterval: 12,
      isMobileViewport: false,
      debouncedCheckPath: null
    };
  },
  async mounted() {
    console.log('mounted home');
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.updateViewport);
    this.updateViewport();
    this.MAIN_URL = constant.MAIN_URL;
    this.$store.commit("player/SET_LOADED_SONGS", 0);
    if (this.$route.name === 'HomeSoundEffects' || this.$route.path === '/soundeffects') {
      await this.getSoundEffects();
    } else if (this.slug && this.type) {
      await this.getFilteredSongs(this.slug, this.type);
    } else {
      await this.getSongs();
    }
    await this.restoreListingState();
    this.$store.commit("player/SET_IS_LOADING", false);
    if (this.$route.name === 'HomeSearch' || this.$route.name === 'HomeMusic') {
      setTimeout(() => {
        this.scrollToResults();
      }, 250);
    }
    this.debouncedCheckPath = debounce(this.checkPath, 300);
    this.checkPath();
  },
  updated() {
    if (typeof this.debouncedCheckPath === 'function') {
      this.debouncedCheckPath();
    }
  },
  methods: {
    showInFeedAd(index) {
      // Insert a reserved horizontal ad after every Nth track, but never as
      // the final list item (the pre-footer ad already sits at the bottom).
      if (this.isMobileViewport) {
        return false;
      }
      const n = this.inFeedAdInterval;
      const total = this.songs ? this.songs.length : 0;
      return (index + 1) % n === 0 && (index + 1) < total;
    },
    updateViewport() {
      this.isMobileViewport = window.innerWidth < 768;
    },
    trackEvent(eventName, dimensions = {}) {
      if (window.viberaryTrackEvent) {
        window.viberaryTrackEvent(eventName, Object.assign({
          list_context: this.songType || this.$route.name || 'home',
          page_number: this.paginationNumber,
          device_class: window.innerWidth < 768 ? 'mobile' : 'desktop'
        }, dimensions));
      }
    },
    saveListingState() {
      try {
        const selected = this.selectedSong ? {
          id: this.selectedSong.id,
          slug: this.selectedSong.slug,
          title: this.selectedSong.title
        } : null;
        sessionStorage.setItem('viberaryListingState', JSON.stringify({
          path: this.$route.fullPath,
          scrollY: window.pageYOffset || document.documentElement.scrollTop || 0,
          loadedCount: this.songs ? this.songs.length : 0,
          paginationNumber: this.paginationNumber,
          selectedSong: selected,
          isPlaying: this.isPlaying
        }));
      } catch (e) {}
    },
    async restoreListingState() {
      if (this.restoreStateApplied) return;
      this.restoreStateApplied = true;
      try {
        const raw = sessionStorage.getItem('viberaryListingState');
        if (!raw) return;
        const state = JSON.parse(raw);
        if (!state || state.path !== this.$route.fullPath) return;
        const targetCount = state.loadedCount || 0;
        while (this.pagination && this.pagination.next_page_url && this.songs && this.songs.length < targetCount) {
          await this.addSong();
        }
        if (state.selectedSong) {
          this.$store.commit('player/SET_SELECTED_SONG', state.selectedSong);
          this.$store.commit('player/SET_SHOW_STICKY_PLAYER', true);
          this.$store.commit('player/SET_IS_PLAYING', !!state.isPlaying);
        }
        setTimeout(() => window.scrollTo(0, state.scrollY || 0), 250);
      } catch (e) {}
    },
    async loadMoreFromButton() {
      this.trackEvent('load_more_click');
      this.trackEvent('pagination_click', { page_number: this.paginationNumber + 1 });
      await this.addSong();
    },
    ...mapActions({
      fetchSongs: 'player/fetchSongs',
      fetchAddedSongs: 'player/fetchAddedSongs',
    }),

    apiSlugForType(type, slug) {
      if (type === 'tempo') {
        const single = String(slug || '').match(/^(\d+)-bpm$/);
        const range = String(slug || '').match(/^(\d+)-(\d+)-bpm$/);
        if (range) return JSON.stringify([parseInt(range[1]), parseInt(range[2])]);
        if (single) return JSON.stringify([parseInt(single[1]), parseInt(single[1])]);
      }
      return slug;
    },
    async getFilteredSongs(slug, type) {
      this.resetListForNewContext();
      const apiSlug = this.apiSlugForType(type, slug);
      await this.fetchSongs({ url: `${this.MAIN_URL}/api/${type}/${encodeURIComponent(apiSlug)}` });
      if (this.songs) {
        this.songs.forEach((song, index) => this.trackEvent('track_impression', {
          track_id: song.id, slug: song.slug, title: song.title, tempo: song.tempo, position: index + 1, page_number: 1
        }));
      }
    },
    resetListForNewContext() {
      if (this.currentWavesurfer) {
        try {
          this.currentWavesurfer.stop();
        } catch (e) {}
      }
      this.$store.commit("player/SET_WAVESURFER", null);
      this.$store.commit("player/SET_SELECTED_SONG", null);
      this.$store.commit("player/SET_CURRENT_INDEX", 0);
      this.$store.commit("player/SET_IS_PLAYING", false);
      this.$store.commit("player/SET_SHOW_STICKY_PLAYER", false);
      this.paginationNumber = 1;
      this.isLastPage = false;
      this.loadMore = false;
      this.$store.commit("player/SET_LOAD_MORE", false);
      this.$store.commit("player/SET_LOADED_SONGS", 0);
    },
    scrollToResults() {
      const target = document.querySelector('.playlist-wrap') || document.getElementById('main');
      if (target) {
        const header = document.querySelector('.header-wrap');
        const headerOffset = header ? header.getBoundingClientRect().height : 0;
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }
    },

    checkPath() {
      // alert('checkPath');
      if (location.pathname === '/soundeffects') {
        this.isSoundEffect = true;
      } else {
        this.isSoundEffect = false;
      }
    },

    async addSong() {
      if (!this.pagination || !this.pagination.next_page_url || this.loadMore) {
        this.isLastPage = true;
        return;
      }
      let pageNumber = this.$route.query.page || null;
      this.paginationNumber = this.paginationNumber + 1;
      console.log('new songs before', this.added_songs);

      var self = this;
      let url = this.pagination.next_page_url;
      // Check if the current route contains a genre
      // if (this.$route.path.includes('/genre/')) {
      //   // Extract genre from the path
      //   let genre = this.$route.path.split('/genre/')[1].split('/')[0];
      //   // Construct URL for genre-based pagination
      //   url = `${this.MAIN_URL}/genre/${genre}?page=${this.paginationNumber}`;
      // } else {
      //   // Default playlist pagination URL
      //   url = `${this.MAIN_URL}/api/playlist?page=${this.paginationNumber}`;
      // }
      if(url){
        this.loadMore = true;
        this.$store.commit("player/SET_LOAD_MORE", this.loadMore);
        await self.fetchAddedSongs({url:url});

        setTimeout(() => {

          const existingIds = new Set(self.songs.map(item => item.id));
          this.added_songs.forEach((song, offset) => {
            if (!existingIds.has(song.id)) {
              self.songs.push(song);
              existingIds.add(song.id);
              self.trackEvent('track_impression', {
                track_id: song.id, slug: song.slug, title: song.title, tempo: song.tempo,
                position: self.songs.length, page_number: self.paginationNumber
              });
            }
          });
          this.isLastPage = !this.pagination.next_page_url;

          self.loadMore = false;
          self.$store.commit("player/SET_LOAD_MORE", self.loadMore);
        }, 1500);

        console.log('new songs after', this.added_songs);
      }

    },

    async addSoundEffects() {
      console.log('addSoundEffects');
      if (!this.pagination || !this.pagination.next_page_url || this.loadMore) {
        this.isLastPage = true;
        return;
      }
      this.paginationNumber += 1;
      var url = this.pagination.next_page_url;
      this.loadMore = true;
      this.$store.commit("player/SET_LOAD_MORE", this.loadMore);
      await this.fetchAddedSongs({ url });
      const existingIds = new Set((this.songs || []).map(item => item.id));
      (this.added_songs || []).forEach((song) => {
        if (!existingIds.has(song.id)) {
          this.songs.push(song);
          existingIds.add(song.id);
        }
      });
      this.isLastPage = !this.pagination.next_page_url;
      this.loadMore = false;
      this.$store.commit("player/SET_LOAD_MORE", this.loadMore);
    },
    async getSoundEffects() {
      this.resetListForNewContext();
      this.isSoundEffect = true;
      await this.fetchSongs({ url: `${this.MAIN_URL}/api/soundeffects_playlist` });
      if (this.songs) {
        this.songs.forEach((song, index) => this.trackEvent('track_impression', {
          track_id: song.id, slug: song.slug, title: song.title, tempo: song.tempo, position: index + 1, page_number: 1
        }));
      }
    },
    async getSongsOfPage(url) {
      console.log('getSongsOfPage', url);
      if (this.loadedSongs !== (this.songs ? this.songs.length : 0) || this.loadedSongs === 0) {
        this.$store.commit("player/SET_LOADED_SONGS", 0);
        if (this.selectedSong && this.selectedSong.wavesurfer) {
          this.selectedSong.wavesurfer.stop();
          this.selectedSong.wavesurfer.destroyAllPlugins();
        }
        this.$store.commit("player/SET_IS_PLAYING", false);
        this.$store.commit("player/SET_SHOW_STICKY_PLAYER", false);
        // this.$store.commit("player/SET_SELECTED_SONG", null);
        await this.fetchSongs({ url });
      }
    },
    async getSongs() {
      console.log('getSongs');
      this.resetListForNewContext();
      let result = await this.fetchSongs({ url: `${this.MAIN_URL}/api/playlist` });
      if (result.status && this.songs.length > 1) {
        this.playlistSongLabel = 'Songs';
      }
      if (this.songs) {
        this.songs.forEach((song, index) => this.trackEvent('track_impression', {
          track_id: song.id, slug: song.slug, title: song.title, tempo: song.tempo, position: index + 1, page_number: 1
        }));
      }
    },
    selectSong(song) {
      console.log('selectSong', song);
      this.$store.commit("player/SET_SELECTED_SONG", song);
      this.playSong(song);
    },
    playSong(song) {
      console.log('playSong', song);
      // Implement play song logic
    },
    playAll() {
      console.log('playAll');
      if (!this.hasPlayableSong) {
        return;
      }
      const currentIsInVisibleList = this.selectedSong && this.songs && this.songs.some(song => song.id === this.selectedSong.id);
      if (this.currentWavesurfer && currentIsInVisibleList) {
        this.currentWavesurfer.playPause();
        this.$store.commit("player/SET_IS_PLAYING", this.currentWavesurfer.isPlaying());
        this.$store.commit("player/SET_SHOW_STICKY_PLAYER", this.currentWavesurfer.isPlaying());
      } else if (this.songs && this.songs.length) {
        if (this.currentWavesurfer && this.currentWavesurfer.isPlaying()) {
          this.currentWavesurfer.stop();
        }
        this.$store.commit("player/SET_SELECTED_SONG", null);
        this.$store.commit("player/SET_CURRENT_INDEX", 0);
        const firstSong = this.songs.find(song => song && song.isReady) || this.songs[0];
        let playButton = document.getElementById(firstSong.id) || document.querySelector('.queue .pause-play');
        if (!playButton) {
          return;
        }
        playButton.click();
      }
    },
    downloadSong(song) {
      console.log('downloadSong', song);
      if (song) {
        if (song.wavesurfer && song.wavesurfer.isPlaying()) {
          song.wavesurfer.pause();
        }
        this.$router.push({ path: `/download/${song.slug}` });
      }
    },
    async handleScroll() {
      // console.log('handleScroll');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollTop + windowHeight >= documentHeight - 250) {
        await this.triggerBottomEvent();
      }
    },
    async triggerBottomEvent() {
      console.log('triggerBottomEvent');
      if (!this.loadMore) {
        if (location.pathname == '/soundeffects') {
          await this.addSoundEffects();
        } else if (this.pagination && this.pagination.next_page_url) {
          await this.addSong();
        }
      }
    },
  },
  watch: {
    '$route.fullPath': async function () {
      if (this.$route.name === 'HomeSoundEffects' || this.$route.path === '/soundeffects') {
        await this.getSoundEffects();
      } else if (this.slug && this.type) {
        await this.getFilteredSongs(this.slug, this.type);
      } else {
        await this.getSongs();
      }
      this.scrollToResults();
    }
  },
  beforeDestroy() {
    this.saveListingState();
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.updateViewport);
  },
  computed: {
    libraryIntro() {
      if (!this.type || !this.slug || !['genre', 'mood'].includes(this.type)) {
        return null;
      }
      return categoryLandingContent[`${this.type}:${this.slug}`] || null;
    },
    libraryHeading() {
      return (this.libraryIntro && this.libraryIntro.title) || this.categoryName || 'Hot Picks';
    },
    nextPageHref() {
      const nextPage = this.paginationNumber + 1;
      const basePath = this.$route.path === '/' || this.$route.path === '/homemusic' ? '/music' : this.$route.path;
      return `${basePath.replace(/\/page\/\d+$/, '')}/page/${nextPage}`;
    },
    hasPlayableSong() {
      return !!(this.songs && this.songs.length);
    },
    isLongPlaylistTitle() {
      return !!(this.categoryName && this.categoryName.length > 34);
    },
    showReferralFinderPromo() {
      return [
        'Home',
        'HomeGenre',
        'HomeMood',
        'HomeSearch',
        'HomeTempo',
        'HomeMusic',
        'HomeMusicPage',
        'HomeMusicLegacy',
        'HomeSoundEffects'
      ].includes(this.$route.name);
    },
    ...mapGetters({
      songs: 'player/getSongs',
      selectedSong: 'player/getSelectedSong',
      currentVolume: 'player/getVolume',
      isPlaying: 'player/getIsPlaying',
      pagination: 'player/getPagination',
      loadedSongs: 'player/getLoadedSongs',
      categoryName: 'player/getCategoryName',
      songType: 'player/getType',
      added_songs: 'player/getAddedSongs',
      currentWavesurfer: 'player/getCurrentWaveSurfer',
    }),
  }
};
</script>
